import { PrimaryStatus, SecondaryStatus } from 'types/api/responses';

/**
 * Diccionario de traducciones de estados primarios
 */
export const primaryStatusTranslations: Record<PrimaryStatus, string> = {
  'New': 'Nuevo',
  'Active': 'Activo',
  'Inactive': 'Inactivo',
};

/**
 * Diccionario de traducciones de estados secundarios (documentales)
 */
export const secondaryStatusTranslations: Record<SecondaryStatus, string> = {
  'PendingDocuments': 'Documentos Pendientes',
  'DocsOK': 'Documentos OK',
  'PendingVerification': 'Pendiente de Verificación',
};

/**
 * Obtiene la traducción de un estado primario
 * @param status - Estado primario en inglés
 * @returns Traducción en español
 */
export const getPrimaryStatusLabel = (status: PrimaryStatus): string => {
  return primaryStatusTranslations[status] || status;
};

/**
 * Obtiene la traducción de un estado secundario
 * @param status - Estado secundario en inglés
 * @returns Traducción en español
 */
export const getSecondaryStatusLabel = (status: SecondaryStatus): string => {
  return secondaryStatusTranslations[status] || status;
};

/**
 * Obtiene el color asociado a un estado primario
 * @param status - Estado primario
 * @returns Código de color en hexadecimal
 */
export const getPrimaryStatusColor = (status: PrimaryStatus): string => {
  switch (status) {
    case 'Active':
      return '#2e7d32';
    case 'New':
      return '#1565c0';
    case 'Inactive':
      return '#757575';
    default:
      return '#666666';
  }
};

/**
 * Obtiene el color asociado a un estado secundario
 * @param status - Estado secundario
 * @returns Código de color en hexadecimal
 */
export const getSecondaryStatusColor = (status: SecondaryStatus): string => {
  switch (status) {
    case 'DocsOK':
      return '#2e7d32';
    case 'PendingVerification':
      return '#e65100';
    case 'PendingDocuments':
      return '#f57f17';
    default:
      return '#666666';
  }
};
